import React from 'react';

import { FormControl, InputLabel, Select, MenuItem, FormHelperText, Box } from '@mui/material';
import { useCategories } from '@app/hooks/useCategories';

const CategorySelect = ({ watch, setValue, errors }: any) => {
  const { categories } = useCategories();
  const categoryId = watch('categoryId');

  return (
    <Box>
      <FormControl error={!!errors?.categoryId} sx={{ minWidth: 200 }}>
        <InputLabel id="category-select-label">Category</InputLabel>
        <Select
          labelId="category-select-label"
          id="category-select"
          label="Category"
          value={categoryId || ''}
          onChange={(e) => {
            const { value } = e.target;

            setValue('categoryId', value, { shouldValidate: true });
          }}
        >
          {categories.map((cat) => (
            <MenuItem key={cat.id} value={cat.id}>
              {cat.title || cat.nameEn || cat.nameAm || cat.id}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{errors?.categoryId?.message}</FormHelperText>
      </FormControl>
    </Box>
  );
};

export default CategorySelect;
